exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1ff68fdb] .el-tabs--bottom .el-tabs__header.is-bottom{margin-top:0}[data-v-1ff68fdb] .el-tabs__item{font-weight:700;font-size:15px;padding:0 20px!important}[data-v-1ff68fdb] .el-tabs__active-bar{display:none}[data-v-1ff68fdb] .el-tabs__item.is-active{color:#ec1c1c;border-bottom:2px solid #ec1c1c}[data-v-1ff68fdb] .el-tabs__item:hover{color:#ec1c1c}[data-v-1ff68fdb] .el-tabs__nav-wrap:after{height:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ff68fdb","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./pages/judicialService/arbitration.vue
// module id = 7M/7
// module chunks = 81